export default {
  // 页面标题
  'smsReport.title': '短信报表',
  'smsReport.subtitle': '短信发送统计和分析报表',

  // 表单字段
  'smsReport.form.timeRange': '时间范围',
  'smsReport.form.timeRangeRequired': '请选择时间范围',
  'smsReport.form.startDate': '开始日期',
  'smsReport.form.endDate': '结束日期',
  'smsReport.form.startTime': '开始时间',
  'smsReport.form.startTimeRequired': '请选择开始时间',
  'smsReport.form.startTimePlaceholder': '请选择开始时间',
  'smsReport.form.endTime': '结束时间',
  'smsReport.form.endTimeRequired': '请选择结束时间',
  'smsReport.form.endTimePlaceholder': '请选择结束时间',
  'smsReport.form.taskName': '任务',
  'smsReport.form.taskNamePlaceholder': '请输入任务名称',
  'smsReport.form.taskType': '类型',
  'smsReport.form.taskTypePlaceholder': '请选择类型',
  'smsReport.form.groupBy': '分组方式',
  'smsReport.form.groupByTooltip': '选择数据的分组统计方式',

  // 任务类型
  'smsReport.taskType.all': '全部类型',
  'smsReport.taskType.bulk': '群发',
  'smsReport.taskType.automation': '自动化',
  'smsReport.taskType.ndc': '注册未存款',
  'smsReport.taskType.inactive': '沉默用户',
  'smsReport.taskType.churn': '流失用户',
  'smsReport.taskType.vip': 'VIP任务',
  'smsReport.taskType.welcome': '欢迎短信',
  'smsReport.taskType.restorage': '存款用户',
  'smsReport.taskType.birthday': '生日提醒',
  'smsReport.taskType.unknown': '未知',

  // 分组选项
  'smsReport.groupBy.day': '按日分组',
  'smsReport.groupBy.month': '按月分组',
  'smsReport.groupBy.task': '按任务分组',

  // 按钮
  'smsReport.button.search': '查询',
  'smsReport.button.reset': '重置',
  'smsReport.button.export': '导出报表',

  // 统计卡片
  'smsReport.stats.totalSend': '总发送量',
  'smsReport.stats.successSend': '成功发送',
  'smsReport.stats.failSend': '发送失败',
  'smsReport.stats.avgSuccessRate': '平均成功率',
  'smsReport.stats.totalCost': '总成本',

  // 表格列头
  'smsReport.table.task': '任务',
  'smsReport.table.type': '类型',
  'smsReport.table.taskName': '任务名称',
  'smsReport.table.taskType': '任务类型',
  'smsReport.table.sendCount': '发送量',
  'smsReport.table.successCount': '成功数量',
  'smsReport.table.failCount': '失败数量',
  'smsReport.table.successRate': '成功率',
  'smsReport.table.cost': '成本',
  'smsReport.table.date': '日期',
  'smsReport.table.actions': '操作',
  'smsReport.table.viewLogs': '查看日志',

  // 日志弹窗
  'smsReport.logs.title': '短信日志',
  'smsReport.logs.time': '时间',
  'smsReport.logs.task': '任务',
  'smsReport.logs.user': '用户',
  'smsReport.logs.phone': '手机号',
  'smsReport.logs.channel': '通道',
  'smsReport.logs.status': '状态',
  'smsReport.logs.receipt': '回执码',
  'smsReport.logs.statusPending': '待发送',
  'smsReport.logs.statusSuccess': '成功',
  'smsReport.logs.statusFailed': '失败',

  // 消息提示
  'smsReport.message.selectTimeRange': '请选择时间范围',
  'smsReport.message.exportSuccess': '导出成功',
  'smsReport.message.exportFailed': '导出失败',
  'smsReport.message.exporting': '正在导出数据...',
  'smsReport.message.queryFailed': '查询失败',
  'smsReport.message.noData': '暂无数据',

  // 提示信息
  'smsReport.hint.selectQuery': '请选择查询条件后点击查询按钮',
  'smsReport.hint.exportNote': '导出功能将生成Excel格式的报表文件',
  'smsReport.hint.timeRangeLimit': '时间范围不能超过90天',

  // 状态标签
  'smsReport.status.high': '高',
  'smsReport.status.medium': '中',
  'smsReport.status.low': '低',

  // 货币单位
  'smsReport.currency.usd': '美元',
  'smsReport.currency.cny': '人民币',
  'smsReport.currency.php': '菲律宾比索',
  'smsReport.currency.vnd': '越南盾',

  // 分页
  'smsReport.pagination.total': '共 {{total}} 条记录'
};
